import { useEffect } from 'react';
import { useTheme } from '../../context/ThemeContext.jsx';
import { ensureLoaded } from '../../hooks/useFontFaceLoader.js';

const SIZES = [12, 16, 20, 24, 32, 48, 64, 96];

export default function WaterfallTab({ font, previewText }) {
  const { theme } = useTheme();
  const text = previewText || 'The quick brown fox jumps over the lazy dog';

  useEffect(() => {
    ensureLoaded(font);
  }, [font?.id]);

  return (
    <div>
      {SIZES.map(size => (
        <div key={size} style={{
          padding: '8px 0',
          borderBottom: `1px solid ${theme.borderLight}`,
          display: 'flex', alignItems: 'baseline', gap: 12,
        }}>
          <span style={{
            fontSize: 10, color: theme.textGhost, fontWeight: 600,
            minWidth: 28, textAlign: 'right', flexShrink: 0,
            fontFamily: "'Aeonik', Arial, Helvetica, sans-serif",
          }}>{size}</span>
          <span style={{
            fontFamily: `'${font.family}', serif`,
            fontSize: size, lineHeight: 1.3,
            color: theme.textSecondary,
            overflow: 'hidden', textOverflow: 'ellipsis',
            whiteSpace: 'nowrap', flex: 1,
          }}>{text}</span>
        </div>
      ))}
    </div>
  );
}
